import React from 'react';
import Uganda_p7 from './uganda_p7';
import Uganda_p7_subjects from './uganda_p7_subjects';
const Uganda_p7eng = () => {
  return (
    <div>
     <Uganda_p7 />
    <Uganda_p7_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1> English</h1>
      <h3>English content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in English learning and assessment </li>
      <li>Cross-cutting isues integrated in English learning and assessment </li>
      <li>Values integrated in English learning and assessment </li>
      <li>Generic skills or Soft skills or 21st century skills integrated in English learning and assessment </li>
      <li>Cross-cutting isues integrated in English learning and assessment </li>
      <li>Values integrated in English learning and assessment </li>
      <p>To be barbaric primarily means to be extremely cruel, brutal, or uncivilized. The word's meaning has <br /> evolved from a simple description of foreigners to a strong term of moral disapproval. </p>
    </div>  
    </div>
  );
}

export default Uganda_p7eng;